import React, { useState } from 'react';

const PendingSwitching = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedOperator, setSelectedOperator] = useState('all');
  
  const [switchingData, setSwitchingData] = useState([
    {
      id: 1,
      transactionId: 'TXN2025110512345',
      operator: 'Airtel',
      amount: '299',
      currentAPI: 'API Provider 1',
      targetAPI: 'API Provider 2',
      reason: 'Timeout',
      pendingSince: '10 mins',
      customerMobile: '9876543210',
      status: 'Pending'
    },
    {
      id: 2,
      transactionId: 'TXN2025110512346',
      operator: 'Vodafone',
      amount: '499',
      currentAPI: 'API Provider 2',
      targetAPI: 'API Provider 3',
      reason: 'API Failure',
      pendingSince: '25 mins',
      customerMobile: '9123456789',
      status: 'Pending'
    },
    {
      id: 3,
      transactionId: 'TXN2025110512347',
      operator: 'Jio',
      amount: '666',
      currentAPI: 'API Provider 1',
      targetAPI: 'API Provider 4',
      reason: 'High Load',
      pendingSince: '5 mins',
      customerMobile: '8765432109',
      status: 'Pending'
    },
    {
      id: 4,
      transactionId: 'TXN2025110512348',
      operator: 'BSNL',
      amount: '99',
      currentAPI: 'API Provider 3',
      targetAPI: 'API Provider 1',
      reason: 'Service Down',
      pendingSince: '45 mins',
      customerMobile: '7654321098',
      status: 'Pending'
    }
  ]);

  const operators = ['all', ...new Set(switchingData.map(item => item.operator))];

  const filteredData = switchingData.filter(item => {
    const matchesSearch = 
      item.transactionId.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.operator.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.customerMobile.includes(searchTerm);
    
    const matchesOperator = selectedOperator === 'all' || item.operator === selectedOperator;
    
    return matchesSearch && matchesOperator;
  });

  const handleProcess = (id) => {
    setSwitchingData(switchingData.map(item => 
      item.id === id 
        ? { ...item, status: 'Processing' }
        : item
    ));
    // Simulate processing
    setTimeout(() => {
      setSwitchingData(prev => prev.filter(item => item.id !== id));
    }, 1000);
  };

  const handleReject = (id) => {
    setSwitchingData(switchingData.filter(item => item.id !== id));
  };

  return (
    <div className="container-fluid p-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h2 className="mb-1">Pending Switching</h2>
          <p className="text-muted mb-0">Review and process pending API switch requests</p>
        </div>
        <button className="btn btn-success">
          <i className="bi bi-check-all me-2"></i>
          Process All
        </button>
      </div>

      <div className="card mb-4">
        <div className="card-body">
          <div className="row g-3">
            <div className="col-md-6">
              <label className="form-label">Search</label>
              <div className="input-group">
                <span className="input-group-text">
                  <i className="bi bi-search"></i>
                </span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by transaction ID, operator, or mobile..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>
            <div className="col-md-6">
              <label className="form-label">Filter by Operator</label>
              <select
                className="form-select"
                value={selectedOperator}
                onChange={(e) => setSelectedOperator(e.target.value)}
              >
                {operators.map((operator, index) => (
                  <option key={index} value={operator}>
                    {operator === 'all' ? 'All Operators' : operator}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>

      <div className="row mb-4">
        <div className="col-md-3 mb-3">
          <div className="card bg-warning text-white">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="mb-1">Pending Requests</h6>
                  <h3 className="mb-0">{switchingData.length}</h3>
                </div>
                <i className="bi bi-hourglass-split fs-1 opacity-50"></i>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-3 mb-3">
          <div className="card bg-danger text-white">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="mb-1">Critical (>30m)</h6>
                  <h3 className="mb-0">
                    {switchingData.filter(item => 
                      parseInt(item.pendingSince) > 30
                    ).length}
                  </h3>
                </div>
                <i className="bi bi-exclamation-triangle-fill fs-1 opacity-50"></i>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-3 mb-3">
          <div className="card bg-info text-white">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="mb-1">Total Amount</h6>
                  <h3 className="mb-0">
                    ₹{switchingData.reduce((sum, item) => sum + parseInt(item.amount), 0)}
                  </h3>
                </div>
                <i className="bi bi-currency-rupee fs-1 opacity-50"></i>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-3 mb-3">
          <div className="card bg-primary text-white">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="mb-1">Avg Wait Time</h6>
                  <h3 className="mb-0">21 mins</h3>
                </div>
                <i className="bi bi-clock-fill fs-1 opacity-50"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-hover">
              <thead className="table-light">
                <tr>
                  <th>Transaction ID</th>
                  <th>Operator</th>
                  <th>Amount</th>
                  <th>Mobile</th>
                  <th>Current API</th>
                  <th>Target API</th>
                  <th>Reason</th>
                  <th>Pending Since</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.length > 0 ? (
                  filteredData.map((item) => (
                    <tr key={item.id} className={
                      parseInt(item.pendingSince) > 30 ? 'table-danger' : ''
                    }>
                      <td>
                        <small className="font-monospace">{item.transactionId}</small>
                      </td>
                      <td>
                        <i className="bi bi-phone-fill text-primary me-2"></i>
                        {item.operator}
                      </td>
                      <td>
                        <strong className="text-success">₹{item.amount}</strong>
                      </td>
                      <td>
                        <small>{item.customerMobile}</small>
                      </td>
                      <td>
                        <span className="badge bg-secondary">{item.currentAPI}</span>
                      </td>
                      <td>
                        <span className="badge bg-info">{item.targetAPI}</span>
                      </td>
                      <td>
                        <span className="badge bg-warning text-dark">{item.reason}</span>
                      </td>
                      <td>
                        <span className={`badge ${
                          parseInt(item.pendingSince) > 30 ? 'bg-danger' : 
                          parseInt(item.pendingSince) > 15 ? 'bg-warning text-dark' : 
                          'bg-secondary'
                        }`}>
                          {item.pendingSince}
                        </span>
                      </td>
                      <td>
                        <div className="btn-group btn-group-sm" role="group">
                          <button 
                            className="btn btn-outline-success" 
                            title="Process"
                            onClick={() => handleProcess(item.id)}
                          >
                            <i className="bi bi-check-circle"></i>
                          </button>
                          <button 
                            className="btn btn-outline-danger" 
                            title="Reject"
                            onClick={() => handleReject(item.id)}
                          >
                            <i className="bi bi-x-circle"></i>
                          </button>
                          <button className="btn btn-outline-primary" title="View Details">
                            <i className="bi bi-eye"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center py-5">
                      <i className="bi bi-check-circle fs-1 text-success d-block mb-2"></i>
                      <p className="text-muted mb-0">No pending requests found</p>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div className="card-footer">
          <div className="d-flex justify-content-between align-items-center">
            <div className="text-muted">
              Showing {filteredData.length} of {switchingData.length} pending requests
            </div>
            <div>
              <button className="btn btn-sm btn-outline-primary me-2">
                <i className="bi bi-download me-1"></i>
                Export
              </button>
              <button className="btn btn-sm btn-outline-secondary">
                <i className="bi bi-arrow-clockwise me-1"></i>
                Refresh
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PendingSwitching;

